import React from "react";
import "./CtaBanner.css";

const CtaBanner = () => {
  const whatsappNumber = "919727983039";

  const handleWhatsApp = () => {
    const message = encodeURIComponent(
      "Hello, I would like to inquire about pricing, bulk orders and delivery across India."
    );
    window.open(`https://wa.me/${whatsappNumber}?text=${message}`, "_blank");
  };

  return (
    <section className="hm-cta-section">
      <div className="hm-cta-container">
        <h2 className="hm-cta-title">Need bulk or custom orders for MultiFct?</h2>
        <p className="hm-cta-subtitle">
          Message us directly on WhatsApp for wholesale pricing, bulk packs, and express delivery across India.
        </p>

        <button className="hm-cta-btn" onClick={handleWhatsApp}>
          <svg
            className="hm-cta-btn-icon"
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <path d="M20.5 3.5A11.7 11.7 0 0 0 12.1 0C5.6 0 .3 5.3.3 11.8c0 2.1.5 4.1 1.6 5.9L.2 24l6.4-1.7a11.8 11.8 0 0 0 5.5 1.4h.1c6.5 0 11.8-5.3 11.8-11.8 0-3.2-1.2-6.2-3.5-8.4ZM12.1 21.7c-1.8 0-3.6-.5-5.1-1.4l-.4-.2-3.8 1 1-3.7-.2-.4a9.8 9.8 0 1 1 8.5 4.7Zm5.4-7.4c-.3-.2-1.7-.9-2-.9-.3-.1-.5-.2-.7.2-.2.3-.7.9-.9 1.1-.2.2-.3.2-.6.1-.3-.2-1.2-.5-2.3-1.5-.9-.8-1.5-1.7-1.7-2-.2-.3 0-.5.1-.6l.4-.5c.1-.2.2-.3.3-.5.1-.2 0-.4 0-.5-.1-.1-.6-1.5-.9-2-.2-.5-.5-.5-.7-.5h-.6c-.2 0-.5.1-.8.4-.3.3-1 1-1 2.4s1 2.8 1.2 3c.1.2 2 3.2 5 4.5.7.3 1.2.5 1.7.6.7.2 1.3.2 1.8.1.6-.1 1.7-.7 2-1.4.2-.7.2-1.3.1-1.4-.1-.1-.3-.2-.6-.4Z" />
          </svg>
          Order on WhatsApp
        </button>
      </div>
    </section>
  );
};

export default CtaBanner;
